import { Instagram, Facebook, Youtube } from "lucide-react";

const PinterestIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.162-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.099.12.112.225.085.345-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.401.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.354-.629-2.758-1.379l-.749 2.848c-.269 1.045-1.004 2.352-1.498 3.146 1.123.345 2.306.535 3.55.535 6.607 0 11.985-5.365 11.985-11.987C23.97 5.39 18.592.026 11.985.026" />
  </svg>
);

const SOCIALS = [
  { icon: Instagram, label: "Instagram", href: "https://www.instagram.com/goldenmileinteriors2026/", testid: "social-instagram" },
  { icon: Facebook, label: "Facebook", href: "https://www.facebook.com/profile.php?id=61593060275420", testid: "social-facebook" },
  { icon: PinterestIcon, label: "Pinterest", href: "https://au.pinterest.com/gmicomau/", testid: "social-pinterest" },
  { icon: Youtube, label: "YouTube", href: "https://www.youtube.com/channel/UClQm4dSGf7oK4C7IvO3FVVg", testid: "social-youtube" },
];

export const Footer = () => (
  <footer id="contact" data-testid="site-footer" className="bg-[#0D0A08] border-t border-espresso-600">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-2 gap-12">
      <div>
        <img
          src="/logo-full.png"
          alt="Golden Mile Interiors"
          className="h-28 w-auto"
          data-testid="footer-logo"
        />
        <p className="text-sm text-cream-muted leading-relaxed mt-6 max-w-xs">
          Bespoke cabinet makers, established 2026. Kitchens, wardrobes and living-space
          joinery, precision-machined in our Delacombe workshop.
        </p>
        <p className="font-serif italic text-brass mt-4">Custom Spaces. Lasting Impressions.</p>
        <div className="flex gap-3 mt-8" data-testid="social-links">
          {SOCIALS.map((s) => (
            <a
              key={s.label}
              href={s.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={s.label}
              data-testid={s.testid}
              className="w-10 h-10 border border-espresso-600 flex items-center justify-center text-cream-muted hover:border-brass hover:text-brass transition-colors"
            >
              <s.icon size={18} />
            </a>
          ))}
        </div>
      </div>
      <div>
        <p className="text-xs tracking-[0.25em] uppercase text-brass font-medium">Visit the Workshop</p>
        <ul className="mt-6 space-y-3 text-sm text-cream-muted">
          <li>
            <a
              href="https://www.google.com/maps/search/?api=1&query=10%2F15+Icon+Drive%2C+Delacombe+VIC+3356"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-address-link"
              className="hover:text-brass transition-colors"
            >
              10/15 Icon Drive, Delacombe, VIC 3356
            </a>
          </li>
          <li>
            <a href="mailto:info@goldenmileinteriors.com.au" data-testid="footer-email-link" className="hover:text-brass transition-colors">
              info@goldenmileinteriors.com.au
            </a>
          </li>
          <li className="text-brass/80 tracking-wide">Visits by appointment only</li>
        </ul>
      </div>
    </div>
    <div className="border-t border-espresso-600">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-xs text-cream-muted/60">© {new Date().getFullYear()} Golden Mile Interiors Ltd · ABN 69 403 388 526</p>
        <a href="/admin" data-testid="footer-admin-link" className="text-xs text-cream-muted/60 hover:text-brass transition-colors tracking-wide">
          Workshop Login
        </a>
      </div>
    </div>
  </footer>
);
